import React, { useRef, useState, useEffect } from "react";

export default function SignaturePad({ onChange, height = 180 }) {
    const canvasRef = useRef(null);
    const [drawing, setDrawing] = useState(false);
    const [empty, setEmpty] = useState(true);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        // Set up canvas with DPR scaling for sharpness
        const dpr = window.devicePixelRatio || 1;
        const rect = canvas.getBoundingClientRect();
        canvas.width = rect.width * dpr;
        canvas.height = rect.height * dpr;
        ctx.scale(dpr, dpr);
        ctx.lineCap = "round"; ctx.lineJoin = "round";
        ctx.strokeStyle = "#0B1220"; ctx.lineWidth = 2.4;
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, rect.width, rect.height);
    }, []);

    function pos(e) {
        const rect = canvasRef.current.getBoundingClientRect();
        const touch = e.touches ? e.touches[0] : null;
        const x = (touch ? touch.clientX : e.clientX) - rect.left;
        const y = (touch ? touch.clientY : e.clientY) - rect.top;
        return { x, y };
    }
    function start(e) {
        e.preventDefault();
        const ctx = canvasRef.current.getContext("2d");
        const { x, y } = pos(e);
        ctx.beginPath(); ctx.moveTo(x, y);
        setDrawing(true);
    }
    function move(e) {
        if (!drawing) return;
        e.preventDefault();
        const ctx = canvasRef.current.getContext("2d");
        const { x, y } = pos(e);
        ctx.lineTo(x, y); ctx.stroke();
        if (empty) setEmpty(false);
    }
    function end() {
        if (!drawing) return;
        setDrawing(false);
        if (onChange && !empty) onChange(canvasRef.current.toDataURL("image/png"));
    }
    function clear() {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        const rect = canvas.getBoundingClientRect();
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, rect.width, rect.height);
        setEmpty(true);
        if (onChange) onChange("");
    }

    return (
        <div data-testid="signature-pad">
            <div className="relative bg-white border border-white/15 rounded-sm overflow-hidden" style={{ height }}>
                <canvas
                    ref={canvasRef}
                    className="w-full h-full cursor-crosshair touch-none"
                    onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
                    onTouchStart={start} onTouchMove={move} onTouchEnd={end}
                />
                {empty && (
                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none text-slate-400 text-sm italic">
                        Sign here
                    </div>
                )}
            </div>
            <div className="flex justify-end mt-2">
                <button
                    type="button"
                    data-testid="signature-clear"
                    onClick={clear}
                    className="text-xs text-slate-400 hover:text-gold"
                >
                    Clear signature
                </button>
            </div>
        </div>
    );
}
